// Sync summernote content into its textarea before any remote form submits.
$(document).on('ajax:before', 'form[data-remote]', function() {
  $(this).find('textarea.wysiwyg').each(function() {
    if ($(this).data('summernote')) {
      this.value = $(this).summernote('code');
    }
  });
});

$(document).on('ajax:complete', '[data-remote][data-target]', function(event) {
  var [data, _status, _xhr] = event.detail;
  var location = data.getResponseHeader('Location');

  if (location != null) {
    window.location = location;
    return;
  }

  var target = $(this).data('target');
  var container = $(target).first();

  if (container.hasClass('modal')) {
    bootstrap.Modal.getInstance(container.get(0))?.dispose();
    // dispose() skips the normal hide() path — so ScrollBarHelper never
    // restores body styles and the backdrop stays in the DOM. Clear that
    // residue before the next show() so Bootstrap snapshots a clean
    // "original" state to restore to later.
    resetModalBodyState();
  }

  container.replaceWith(data.responseText);

  if ($(this).data('target-post') === 'modal') {
    var modalEl = $(target).first().get(0);
    if (modalEl) bootstrap.Modal.getOrCreateInstance(modalEl).show();
  } else {
    closeWidgetPickerModal();
  }

  $(document).trigger('data-remote-target-refresh');
});

// When the widget picker/edit modal is dismissed, remove it and restore an
// empty placeholder for the next open. Bootstrap handles backdrop and body
// state itself.
$(document).on('hidden.bs.modal', '#widget-picker-modal', function() {
  bootstrap.Modal.getInstance(this)?.dispose();
  this.replaceWith(buildPlaceholder());
  // Safety net: if no other modal is open, ensure body is fully unlocked.
  if (document.querySelectorAll('.modal.show').length === 0) {
    resetModalBodyState();
  }
});

function closeWidgetPickerModal() {
  var modalEl = document.getElementById('widget-picker-modal');
  if (modalEl) bootstrap.Modal.getInstance(modalEl)?.hide();
}

function buildPlaceholder() {
  var placeholder = document.createElement('div');
  placeholder.id = 'widget-picker-modal-placeholder';
  return placeholder;
}

function resetModalBodyState() {
  document.querySelectorAll('.modal-backdrop').forEach(function(el) { el.remove(); });
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  // Clear Bootstrap's saved "original" snapshot so the next modal starts clean.
  delete document.body.dataset.bsOverflow;
  delete document.body.dataset.bsPaddingRight;
}
